<template>
  <div class="token-page">
    <top-section :loading="loading" />
    <fees-section />
    <crypto-cards />
    <app-section />
    <how-to-order />
    <tarif-section />
    <faq-block bg-color-class="bg--color-10" />
    <subscribe-block />
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'
import { mapActions } from 'vuex'

export default {
  name: 'TokenPage',
  components: {
    TopSection: () => import('@/components/crypto-cards/TopSection.vue'),
    FeesSection: () => import('@/components/crypto-cards/FeesSection.vue'),
    CryptoCards: () => import('@/components/crypto-cards/CryptoCards.vue'),
    AppSection: () => import('@/components/crypto-cards/AppSection.vue'),
    HowToOrder: () => import('@/components/crypto-cards/HowToOrder.vue'),
    TarifSection: () => import('@/components/crypto-cards/TarifSection.vue'),
    FaqBlock: () => import('@/components/welcome/FaqBlock.vue'),
    SubscribeBlock: () => import('@/components/welcome/SubscribeBlock.vue'),
  },
  data () {
    return {
      loading: true,
    }
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.cryptoCards.title'),
      description: this.$t('meta.cryptoCards.description'),
      locale: this.$i18n.locale,
    })
  },
  created () {
    if (!process.client) return

    this.getCardApplicationStatus().finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      getCardApplicationStatus: 'cryptoCards/getCardApplicationStatus',
    }),
  },
}
</script>

<style lang="scss" scoped>
.token-page {

}
</style>
